import { useAds } from "./useAds";

export default function AdsGrid() {
  const { ads } = useAds("grid");
  if (ads.length === 0) return null;

  return (
    <section className="bg-white py-12 md:py-16 px-6" data-testid="ads-grid-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-[#00a86b] font-headings font-bold text-sm uppercase tracking-[0.2em] mb-2">À la une</div>
        <h2 className="font-headings font-black text-3xl md:text-4xl text-[#1a2332] tracking-tight mb-8">Offres en cours</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {ads.map((a) => (
            <article
              key={a.id}
              className="rounded-2xl shadow-md border border-black/5 overflow-hidden flex flex-col hover:-translate-y-1 hover:shadow-xl transition-all"
              style={{
                backgroundColor: a.bg_color || "#FFFFFF",
                color: a.text_color || "#1a2332",
              }}
              data-testid={`ads-grid-card-${a.id}`}
            >
              {a.image_url && (
                <div className="aspect-[16/9] bg-black/5 overflow-hidden">
                  <img src={a.image_url} alt={a.title || ""} className="w-full h-full object-cover" />
                </div>
              )}
              <div className="p-5 flex flex-col flex-1">
                {a.title && <h3 className="font-headings font-black text-lg leading-snug">{a.title}</h3>}
                {a.subtitle && <p className="mt-1 text-sm opacity-90">{a.subtitle}</p>}
                {a.body_text && <p className="mt-2 text-sm opacity-75 whitespace-pre-line">{a.body_text}</p>}
                {a.cta_label && a.cta_url && (
                  <a
                    href={a.cta_url}
                    className="mt-auto pt-4 font-headings font-bold text-sm"
                    style={{ color: a.text_color || "#00a86b" }}
                    data-testid={`ads-grid-cta-${a.id}`}
                  >
                    {a.cta_label} →
                  </a>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
